import http from 'axios'
import {Message} from 'element-ui'
import router from '../router/index.js';
import store from '../store/index';

const axios = http.create({
  timeout: 30000 // 30秒请求超时
});

// request 拦截器
axios.interceptors.request.use(config => {
  // Do something before request is sent
  let baseURL;
  if (config.url.search("/api/admin") !== -1) {
    baseURL = store.getters.java_api; //JAVA接口
  } else {
    baseURL = store.getters.php_api; //PHP接口
  }
  config.url = baseURL + config.url;
  if (store.getters.token) {
    // 让每个请求携带token-- ['Token']为自定义key 请根据实际情况自行修改
    config.headers['Token'] = store.getters.token;
  }
  return config
}, error => {
  // Do something with request error
  console.log("request:" + error) // for debug
  Promise.reject(error)
})

// response 拦截器
axios.interceptors.response.use(
  response => {
    const data = response.data;
    if (data.code == 402 || data.errCode == 402) {
      store.commit('del_token');
      store.commit('del_user');
      store.commit('del_menu');
      store.commit('del_unread');
      document.cookie = "Token=" + encodeURIComponent(store.getters.token) + ";expires=" + new Date(new Date().getTime() - 1).toGMTString();
      router.push('/login');
    } else if (data.code == 403 || data.errCode == 403) {
      router.push('/403')
    } else {
      return response;
    }
  },
  error => {
    console.log('response:' + error); // for debug
    Message({
      message: "操作请求失败，请刷新后重试",
      type: 'error',
      duration: 5 * 1000
    });
    return Promise.reject(error)
  }
);

export default axios



// WEBPACK FOOTER //
// ./src/utils/http.js